module.exports = __webpack_public_path__ + "img/button-background.b410d123.svg";